module.exports = __webpack_public_path__ + "static/img/14.3da14e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/14.png
// module id = zHiu
// module chunks = 0